import { useMemo } from 'react';

import { Eye, EyeOff } from 'lucide-react';
import { DefaultPopover, ButtonIcon } from 'twyne-new.ui';

import { keyOf, NameAndCreateDateFormatter } from '@Components/Grid/components/Table/formatters'
import column, { defaultColumn, defaultActionsColumn, deleteAction, editAction, defaultColumnId, defaultActiveColumn } from '@Components/Grid/utils/column';

import DuplicateEntity from './DuplicatedEntity';

export default function useColumns() {
  return useMemo(() => [
    defaultColumnId(),
    defaultColumn('name', 'Description', info => <NameAndCreateDateFormatter info={info} />),
    column.accessor('type', {
      header: 'Type',
      cell: info => TYPES[info.getValue()],
      enableSorting: false,
    }),
    column.accessor('img', {
      header: 'Image',
      cell: info => <ImageFormatter info={info} />,
      enableSorting: false,
      enableColumnResize: false,
    }),
    column.accessor('points', {
      header: 'Points',
      enableSorting: true,
    }),
    column.accessor('rewardSteps.length', {
      header: 'Steps',
      enableSorting: false,
    }),
    defaultActiveColumn(),
    defaultActionsColumn(editAction, deleteAction, duplicateAction),
  ], [])
}

const duplicateAction = info => <DuplicateEntity key={keyOf(info, 'duplicate')} info={info} />

function ImageFormatter({ info }) {
  const value = info.getValue()

  if (!value) {
    return <EyeOff size={16} className='text-muted-foreground' />
  }

  return <DefaultPopover
    trigger={<ButtonIcon className='twy-text-accent!' content='See image'>
      <Eye size={16} />
    </ButtonIcon>}
    contentProps={{ side: 'bottom' }}
  >
    <img src={value} alt="feature_image" width="100%" />
  </DefaultPopover>
}

const TYPES = {
  deals_only: 'Deals Only',
  points: 'Points',
  master_cashout: 'Master Cashout',
}

